module.exports = __webpack_public_path__ + "static/media/landing.4994b08e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing.jpg
// module id = 28
// module chunks = 0